import {observable} from "mobx";

export default observable({
  timer: null,
  session: null,
  league: gon.league,
  leagues: gon.leagues,
  divisions: gon.divisions,
});